import Order from '../order/Order';

export default function CompanyOrderList() {
  return <Order isCompanyOrder />;
}
